import axios from 'axios'

import { apiUrl } from '@/api/base.js'

export default {
    get_exam_question (number) {
        return axios.get(`${apiUrl}v2/exam_question/${number}`)
    },
    post_exam_question(args){
        return axios.post(`${apiUrl}v2/post_exam_question/`, {params: args})
    }
}